import { render, staticRenderFns } from "./TableBase1110.vue?vue&type=template&id=023956a2&scoped=true&lang=pug&"
import script from "./TableBase1110.vue?vue&type=script&lang=ts&"
export * from "./TableBase1110.vue?vue&type=script&lang=ts&"
import style0 from "./TableBase1110.vue?vue&type=style&index=0&id=023956a2&lang=stylus&scoped=true&"
import style1 from "./TableBase1110.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023956a2",
  null
  
)

export default component.exports